import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvantorHeaderComponent } from '../avantor-header/avantor-header';
import { AvantorFooterComponent } from '../avantor-footer/avantor-footer';
import { UserManualComponent } from './user-manual/user-manual';
import { SoftwareService } from '@core/services/download-center/software/software-api';
import { OrgAndStockroomService } from '@core/services/org-and-stockroom/org-and-stockroom-api';
import { PrivilegeService } from '@core/services/privilege/privilege-api';
import { loadPrivileges, stockroomOrgFetchAPISuccess } from '@core/store/actions/common.actions';
import { AppState } from '@core/store/reducers/common.reducer';
import { getStockroomOrgDetails } from '@core/store/selectors/common.selectors';
import { Store } from '@ngrx/store';
import { SharedModule } from '@shared/shared.module';
import { FormsModule } from '@angular/forms';
import { MaterialsModule } from '@shared/materials.module';

@Component({
  selector: 'app-avantor-layout',
  templateUrl: './avantor-layout.html',
  styleUrls: ['./avantor-layout.scss'],
  standalone: true,
  imports: [UserManualComponent, AvantorHeaderComponent, AvantorFooterComponent, CommonModule, SharedModule, FormsModule, MaterialsModule],
})
export class AvantorLayoutComponent implements OnInit {
  isAdminConsole: string = 'No';
  userManualId: any;


  constructor(
    private privilegeService: PrivilegeService,
    private orgAndStockroomService: OrgAndStockroomService,
    private softwareService: SoftwareService,
    private store: Store<AppState>
  ) {
    this.isAdminConsole = sessionStorage.getItem('isAdminConsole') || 'No';
  }

  ngOnInit(): void {
    this.handleInitialiseStockroomDetails();
    this.handleDispachStockroomOrg();

    //DEMO for fetching stockroom organization details
    this.store.select(getStockroomOrgDetails).subscribe((res: any) => {
    });

    // User manual is only reachable from the non-admin header menu, which fetches the id on demand.
    if (this.isAdminConsole === 'No') {
      this.softwareService.getUserManual('IM Enterprise Manual').subscribe({
        next: (res: any) => {
          this.userManualId = res?.data;
        },
        error: (error: any) => {
          if (error?.status === 401) {
            this.userManualId = null;
          }
        }
      })
    }
  }

  /**
   * initialize and store scokroom and organization
   */
  handleDispachStockroomOrg(): void {
    // this.store.dispatch(invokeStockroomOrgAPI());
    if (this.isAdminConsole == 'No') {
      this.store.dispatch(loadPrivileges());
    }

  }

  /**
   * @INIT_USER_PRIVILEGE
   * - This will trigger privilegeData request
   * for updated privilege of user
   */
  initUserPrivilege() {
    let privileged = this.privilegeService.getPrivilege();
    if (privileged) {
      this.privilegeService.initUserPrivilege().then(userPrivilege => {
        this.privilegeService.setPrivilege(userPrivilege);
      });
    }
  }

  // NOTE: directly dispatch store action without effect
  /**
   * Get current stockroom and org based on im-context
   * and will proceed in updating session org-stockroom
   */
  handleInitialiseStockroomDetails() {


    const currentOrgStockroom = this.orgAndStockroomService.getStockroomAndOrgName();
    let data: any = null;
    if (currentOrgStockroom) {
      data = JSON.parse(currentOrgStockroom);
    }

    if (data && data.organization && data.stockroom) {
      let sessionOrgStk: any = {
        stockroom: data.stockroom,
        organization: data.organization,
      };

      this.store.dispatch(stockroomOrgFetchAPISuccess({
        stockroomOrg: {
          stockroom: data.stockroom,
          organization: data.organization,
        },
      }));
      this.orgAndStockroomService.handleUpdateStockroomOrg(sessionOrgStk);
    } else {
      if (this.isAdminConsole == 'No') {
        this.orgAndStockroomService.getCurrentOrg().then(orgData => {
          this.orgAndStockroomService.getCurrentStockroom().then(stkData => {
            let sessionOrgStk: any = {
              stockroom: stkData,
              organization: orgData,
            };
            this.store.dispatch(stockroomOrgFetchAPISuccess({
              stockroomOrg: {
                stockroom: stkData,
                organization: orgData,
              },
            }));

            //TODO: review
            this.orgAndStockroomService.handleUpdateStockroomOrg(sessionOrgStk);
            this.orgAndStockroomService.setStockroomAndOrgName(
              JSON.stringify(sessionOrgStk)
            );
          });
        });
      }

    }
  }

  getToggleData(event: any, toggleFun: any) {
    toggleFun.toggle();
  }
}
